import dynamic from 'next/dynamic';
import A from './components/A';
import css from './index.module.scss';

const Dynamic = dynamic(() => import('./indexDynamic'), { ssr: true });

export default function Overview({}: any) {
    return (
        <div className={`ecoflow-app-h5 ${css.efAppH5}`}>
            <A />
            <Dynamic />
        </div>
    );
}
